import { Route, Routes } from 'react-router-dom';
import { BikeleasingContractDetailsPage } from './BikeleasingContractDetailsPage';
import { BikeleasingInfoPage } from './BikeleasingInfoPage';
import BikeleasingLearnMorePage from './BikeleasingLearnMorePage';
import { BikeleasingPage } from './BikeleasingPage';

export const BikeleasingRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<BikeleasingPage />} />
      <Route path="/info" element={<BikeleasingInfoPage />} />
      <Route path="/learnmore" element={<BikeleasingLearnMorePage />} />
      <Route path="/contracts/:contractId" element={<BikeleasingContractDetailsPage />} />
    </Routes>
  );
};
